import * as React from 'react';

export default (predicate: boolean, fallback?: React.ComponentType<any>) => (Cmp: React.ComponentType<any>) => (
  props: any,
) =>
  predicate ? <Cmp {...props} /> : fallback ? React.createElement(fallback, {}, props.children) : <>{props.children}</>; // eslint-disable-line
